export default __webpack_public_path__ + "static/media/Locandina-annullato.d84da51b.jpg";